module.exports = __webpack_public_path__ + "img/introduction02_all_03.fb9fa6a5.png";